/* DIEREMA · portada de luxe. JavaScript maison, sans bibliothèque, chargé en « defer » sur l'accueil seulement.
   - La tête : transparente sur la photo, claire en descendant (un seul calcul par image, requestAnimationFrame).
   - Apparitions douces avec IntersectionObserver ; le léger mouvement de la photo chocolat avec
     requestAnimationFrame, uniquement si « réduire les animations » n'est pas demandé et si elle est visible.
   - Menu du téléphone, recherche (vraie recherche Shopify + suggestions /search/suggest.json), favoris
     (dr-wishlist.js : même stockage, même événement) et le panier latéral (dr-cart.js). */
(function () {
  "use strict";
  var doc = document, html = doc.documentElement;
  // Les apparitions ne cachent rien tant que ce script n'a pas démarré (sans lui, tout reste visible).
  html.classList.add("drp-js");
  var reduit = !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  // ---------- un petit message ----------
  var toastEl = $("[data-drp-toast]"), toastT = 0;
  function toast(m) {
    if (!toastEl) return;
    toastEl.textContent = m; toastEl.classList.add("on");
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("on"); }, 1900);
  }

  // ---------- la tête ----------
  var nav = $("#drpNav"), solide = null, rafNav = 0, outils = document.getElementById("drkTools");
  function majNav() {
    rafNav = 0;
    // Pleine aussi dès que la barre des filtres d'une collection arrive sous la tête (jamais transparente sur elle).
    var s = window.scrollY > window.innerHeight * 0.6
      || (outils && outils.getBoundingClientRect().top < nav.getBoundingClientRect().bottom + 8);
    if (s !== solide) { solide = s; nav.classList.toggle("solid", s); }
  }
  if (nav) {
    window.addEventListener("scroll", function () { if (!rafNav) rafNav = requestAnimationFrame(majNav); }, { passive: true });
    majNav();
  }

  // ---------- apparitions ----------
  var aMontrer = $$(".drp-rv");
  if ("IntersectionObserver" in window && !reduit) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.14, rootMargin: "0px 0px -4% 0px" });
    aMontrer.forEach(function (el) { io.observe(el); });
  } else aMontrer.forEach(function (el) { el.classList.add("in"); });

  // ---------- la photo du bloc chocolat bouge un peu en descendant ----------
  var pImg = $(".drp-edito .drp-img img");
  if (pImg && !reduit && "IntersectionObserver" in window) {
    var visible = false, rafP = 0;
    var bouger = function () {
      rafP = 0;
      var r = pImg.parentNode.getBoundingClientRect();
      var p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      pImg.style.transform = "translate3d(0," + (p * -8).toFixed(2) + "%,0)";
    };
    var surDefil = function () { if (visible && !rafP) rafP = requestAnimationFrame(bouger); };
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) surDefil(); }).observe(pImg.parentNode);
    window.addEventListener("scroll", surDefil, { passive: true });
  }

  // ---------- la 2e photo des coups de cœur : chargée seulement au survol (ordinateur) ----------
  $$(".drp-card").forEach(function (c) {
    var b = $("img.b", c);
    if (!b) return;
    c.addEventListener("pointerenter", function (e) {
      if (e.pointerType === "mouse" && !b.srcset) { b.srcset = b.getAttribute("data-srcset"); b.src = b.srcset.split(" ")[0]; }
    });
  });

  // ---------- favoris : le chiffre du cœur (même stockage que dr-wishlist.js) ----------
  var CLE = "dierema:wishlist";
  function favoris() { try { var a = JSON.parse(localStorage.getItem(CLE) || "[]"); return Array.isArray(a) ? a.filter(Boolean) : []; } catch (e) { return []; } }
  var wc = $("[data-drp-wcount]"), wish = $(".drp-wish");
  function majFav(sauter) {
    var n = favoris().length;
    if (!wc) return;
    wc.textContent = n; wc.classList.toggle("on", n > 0);
    if (sauter && wish) { wish.classList.remove("drp-bump"); void wish.offsetWidth; wish.classList.add("drp-bump"); }
  }
  majFav(false);
  doc.addEventListener("dr-wishlist:change", function (e) {
    majFav(true);
    var d = e.detail || {}, nom = "";
    $$("[data-drp-nom]").forEach(function (b) { if (b.closest("dr-wishlist-button").getAttribute("data-product-handle") === d.handle) { nom = b.getAttribute("data-drp-nom"); b.classList.remove("pop"); void b.offsetWidth; b.classList.add("pop"); } });
    toast(d.favorited ? "Ajouté à vos favoris" + (nom ? " · " + nom : "") : "Retiré de vos favoris");
  });
  window.addEventListener("storage", function (e) { if (e.key === CLE) majFav(false); });

  // ---------- le panier latéral ----------
  var sac = $("[data-drp-panier]");
  if (sac) sac.addEventListener("click", function (e) {
    if (window.drCart && window.drCart.ouvrir) { e.preventDefault(); window.drCart.ouvrir(); }
  });

  // ---------- menu du téléphone et recherche ----------
  var tiroir = $("#drpTiroir"), recherche = $("#drpRecherche"), voile = $(".drp-voile"), ouvert = null, avant = null;
  function ouvrir(quoi) {
    fermer(true);
    ouvert = quoi === "menu" ? tiroir : recherche;
    if (!ouvert) return;
    avant = doc.activeElement;
    clearTimeout(ouvert._cache);
    ouvert.classList.add("vu"); void ouvert.offsetWidth;   // affiché d'abord, puis il glisse
    ouvert.classList.add("on"); ouvert.setAttribute("aria-hidden", "false");
    voile.classList.add("on"); html.classList.add("drp-bloque");
    $$('[data-drp-ouvrir="' + quoi + '"]').forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
    setTimeout(function () { var f = quoi === "menu" ? $(".drp-x", tiroir) : $("[data-drp-q]"); if (f) f.focus({ preventScroll: true }); }, 60);
  }
  function fermer(sansFocus) {
    if (!ouvert) return;
    var p = ouvert;
    p.classList.remove("on"); p.setAttribute("aria-hidden", "true");
    p._cache = setTimeout(function () { p.classList.remove("vu"); }, 600);
    voile.classList.remove("on"); html.classList.remove("drp-bloque");
    $$("[data-drp-ouvrir]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    ouvert = null;
    if (!sansFocus && avant && avant.focus) avant.focus({ preventScroll: true });
  }
  $$("[data-drp-ouvrir]").forEach(function (b) { b.addEventListener("click", function () { ouvrir(b.getAttribute("data-drp-ouvrir")); }); });
  $$("[data-drp-fermer]").forEach(function (b) { b.addEventListener("click", function () { fermer(); }); });
  if (voile) voile.addEventListener("touchmove", function (e) { e.preventDefault(); }, { passive: false });
  doc.addEventListener("keydown", function (e) {
    if (!ouvert) return;
    if (e.key === "Escape") { fermer(); return; }
    if (e.key === "Tab") {
      var f = $$("a[href],button,input:not([type=hidden])", ouvert).filter(function (x) { return x.offsetParent; });
      if (!f.length) return;
      if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  // Les suggestions de la recherche de Shopify (les vrais produits), pendant qu'on tape.
  var q = $("[data-drp-q]"), res = $("[data-drp-res]"), tout = $("[data-drp-tout]"), tq = 0, ctrl = null;
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function petite(u) { return u ? u + (u.indexOf("?") < 0 ? "?" : "&") + "width=240" : ""; }
  if (q) q.addEventListener("input", function () {
    clearTimeout(tq);
    var t = q.value.trim();
    if (t.length < 2) { res.innerHTML = ""; tout.hidden = true; return; }
    tq = setTimeout(function () {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch(ROOT + "search/suggest.json?q=" + encodeURIComponent(t) + "&resources[type]=product&resources[limit]=4", ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var p = ((j.resources || {}).results || {}).products || [];
          res.innerHTML = p.length ? p.map(function (x) {
            return '<a href="' + esc(x.url) + '">' + (x.image ? '<img src="' + esc(petite(x.image)) + '" alt="" width="240" height="300" loading="lazy">' : "") + "<b>" + esc(x.title) + "</b>" + esc(x.price ? Math.round(Number(x.price) * 100) / 100 + " €" : "").replace(".", ",") + "</a>";
          }).join("") : '<p style="grid-column:1/-1;color:var(--muted)">Aucun résultat pour « ' + esc(t) + " ».</p>";
          tout.hidden = false;
          var a = $("a", tout); a.href = ROOT + "search?q=" + encodeURIComponent(t);
        })
        .catch(function () {});
    }, 220);
  });

  html.classList.add("drp-pret");
})();
